import type { HttpClient } from '../client';

export interface ScanResolveRequest {
  /** 扫码原始文本（二维码/条码）。 */
  code: string;
  terminal?: 'APP' | 'PDA' | 'MINI' | 'H5' | string;
}

export interface ScanAction {
  action: 'SIGN' | 'DETAIL' | 'STOCKTAKE' | 'APPLY' | 'BIND' | 'OPEN' | string;
  label: string;
  route: string | null;
}

export interface ScanResolveResult {
  /** APPLY / DELIVERY / STOCKTAKE / MATERIAL / BIND_QR / UNKNOWN。 */
  scanType: string;
  code: string;
  matched: boolean;
  bizId: string;
  bizNo: string | null;
  status: string | null;
  summary: string | null;
  extra: Record<string, string | null>;
  nextActions: ScanAction[];
  message: string | null;
}

/**
 * 扫码解析：把码值归一到申领单(SQ)/配送单(PS)/盘点单(PD)/物资编码/绑定二维码。
 * 未识别时 `matched=false` 而不抛错，便于 PDA 继续作业。
 */
export function createScanApi(http: HttpClient) {
  return {
    resolve(body: ScanResolveRequest): Promise<ScanResolveResult> {
      return http.request<ScanResolveResult>({ path: '/wl/scan/resolve', method: 'POST', body });
    }
  };
}

export type ScanApi = ReturnType<typeof createScanApi>;
